import { render, staticRenderFns } from "./DigitalVoting.vue?vue&type=template&id=6ba878ea"
import script from "./DigitalVoting.vue?vue&type=script&lang=js"
export * from "./DigitalVoting.vue?vue&type=script&lang=js"
import style0 from "./DigitalVoting.vue?vue&type=style&index=0&id=6ba878ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports